import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dashboard-ftd-chart" }
const _hoisted_2 = { class: "chart-periods" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "dashboard-single-ftd"
}
const _hoisted_5 = {
  key: 1,
  viewBox: "0 0 560 165",
  role: "img",
  "aria-label": "График FTD sum"
}
const _hoisted_6 = ["y1", "y2"]
const _hoisted_7 = ["points"]
const _hoisted_8 = ["d"]
const _hoisted_9 = ["cx", "cy"]
const _hoisted_10 = {
  x: "28",
  y: "158"
}
const _hoisted_11 = {
  x: "532",
  y: "158",
  "text-anchor": "end"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("small", null, "Динамика FTD sum", -1 /* CACHED */)),
        _createElementVNode("strong", null, _toDisplayString($setup.money($setup.total)), 1 /* TEXT */),
        _cache[1] || (_cache[1] = _createElementVNode("span", null, "за выбранный период", -1 /* CACHED */))
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.periods, ([value,text]) => {
          return _createElementVNode("button", {
            key: value,
            class: _normalizeClass({active:$setup.period===value}),
            onClick: $event => ($setup.period=value)
          }, _toDisplayString(text), 11 /* TEXT, CLASS, PROPS */, _hoisted_3)
        }), 64 /* STABLE_FRAGMENT */))
      ])
    ]),
    ($setup.period===1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("small", null, "FTD sum за день", -1 /* CACHED */)),
          _createElementVNode("strong", null, _toDisplayString($setup.money($setup.points[0]?.value || 0)), 1 /* TEXT */)
        ]))
      : (_openBlock(), _createElementBlock("svg", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([32,83,135], (grid) => {
            return _createElementVNode("line", {
              key: grid,
              x1: "28",
              x2: "532",
              y1: grid,
              y2: grid,
              class: "chart-grid"
            }, null, 8 /* PROPS */, _hoisted_6)
          }), 64 /* STABLE_FRAGMENT */)),
          _createElementVNode("polyline", {
            points: $setup.line,
            class: "ftd-sum-line"
          }, null, 8 /* PROPS */, _hoisted_7),
          ($setup.line)
            ? (_openBlock(), _createElementBlock("path", {
                key: 0,
                d: `M ${$setup.line.replaceAll(' ', ' L ')} L 532,135 L 28,135 Z`,
                class: "ftd-sum-area"
              }, null, 8 /* PROPS */, _hoisted_8))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.points, (point, index) => {
            return (_openBlock(), _createElementBlock("circle", {
              key: point.date,
              cx: $setup.x(index),
              cy: $setup.y(point.value),
              r: "3.5",
              class: "ftd-sum-dot"
            }, [
              _createElementVNode("title", null, _toDisplayString($setup.label(point.date)) + " · " + _toDisplayString($setup.money(point.value)), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_9))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("text", _hoisted_10, _toDisplayString($setup.label($setup.points[0]?.date)), 1 /* TEXT */),
          _createElementVNode("text", _hoisted_11, _toDisplayString($setup.label($setup.points[$setup.points.length-1]?.date)), 1 /* TEXT */)
        ]))
  ]))
}